import { AnyType } from '@src/models/common';
import { IEnvConfig } from './models';

export const getNextEnvConfig = (publicRuntimeConfig: AnyType): IEnvConfig => {
  const apiUrl = publicRuntimeConfig.CEN_api_general_url;
  const cookieName = publicRuntimeConfig.CEN_auth_cookie_name;
  const uiBaseUrl = publicRuntimeConfig.CEN_ui_base_url;
  const authUrl = publicRuntimeConfig.CEN_api_auth_url;
  const authZoneHeaderName = publicRuntimeConfig.CEN_auth_zone_header_name;
  const gtmContainerId = publicRuntimeConfig.CEN_gtmContainerId;
  const platformUrl = publicRuntimeConfig.CEN_ui_platform_base_url;
  const xapilbUrl = publicRuntimeConfig.CEN_xapilb_url;

  return {
    apiUrl,
    cookieName,
    uiBaseUrl,
    authUrl,
    authZoneHeaderName,
    gtmContainerId,
    platformUrl,
    xapilbUrl,
  };
};
